import { Marke } from './Marke.js'

/**
 * Das grosse bewegte Markenzeichen – für die Kontaktseite.
 *
 * Nicht der Roboter. Der gehört in den Fussbereich und ist dort das
 * Maskottchen; auf einer Kontaktseite beantwortet das Bild eine andere Frage,
 * nämlich «mit wem habe ich es zu tun». Die Antwort darauf ist die Marke, und
 * zwar gross genug, dass sie der Gegenstand der Fläche ist und nicht das
 * Zeichen neben der Adresse.
 *
 * Was sich bewegt und warum:
 *
 *   Drei Ringe liegen in verschiedenen Ebenen um das Zeichen und drehen
 *   unterschiedlich schnell, zwei davon gegenläufig. Gleiche Dauer für alle
 *   drei sähe aus wie ein starres Gitter, das man als Ganzes dreht.
 *
 *   Auf zwei Ringen läuft je ein Punkt mit. Er macht die Drehung überhaupt
 *   erst lesbar – ein Kreis ohne Markierung sieht bei jeder Geschwindigkeit
 *   gleich aus.
 *
 *   Das Zeichen selbst schwebt, langsamer als die Ringe, und der Schein
 *   dahinter atmet noch langsamer. Drei Takte, die nie zusammenfallen.
 *
 * Kein WebGL und keine Abhängigkeit: ein SVG und vier Keyframe-Regeln. Die
 * 3D-Laufzeit im Fuss reicht für eine Seite.
 */
export function Markenzeichen(): JSX.Element {
  return (
    <div className="rp-mz">
      <div className="rp-mz-feld">
        <svg viewBox="0 0 320 320" className="rp-mz-svg" aria-hidden="true">
          <defs>
            <radialGradient id="mzSchein" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgba(141,115,255,0.42)" />
              <stop offset="52%" stopColor="rgba(255,142,219,0.12)" />
              <stop offset="100%" stopColor="rgba(0,0,0,0)" />
            </radialGradient>
            <linearGradient id="mzRing" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="rgba(141,115,255,0.12)" />
              <stop offset="50%" stopColor="rgba(255,142,219,0.85)" />
              <stop offset="100%" stopColor="rgba(101,226,255,0.22)" />
            </linearGradient>
          </defs>

          <circle cx="160" cy="160" r="158" fill="url(#mzSchein)" className="rp-mz-atem" />

          <ellipse
            className="rp-mz-ring rp-mz-ring1"
            cx="160"
            cy="160"
            rx="138"
            ry="52"
            fill="none"
            stroke="url(#mzRing)"
            strokeWidth="1.4"
          />
          <ellipse
            className="rp-mz-ring rp-mz-ring2"
            cx="160"
            cy="160"
            rx="52"
            ry="138"
            fill="none"
            stroke="url(#mzRing)"
            strokeWidth="1.4"
          />
          <circle
            className="rp-mz-ring rp-mz-ring3"
            cx="160"
            cy="160"
            r="112"
            fill="none"
            stroke="rgba(185,206,255,0.2)"
            strokeWidth="1"
            strokeDasharray="4 9"
          />

          <circle className="rp-mz-punkt rp-mz-punkt1" cx="298" cy="160" r="4.5" />
          <circle className="rp-mz-punkt rp-mz-punkt2" cx="160" cy="22" r="3.5" />
        </svg>

        <span className="rp-mz-zeichen">
          <Marke groesse={104} mitText={false} />
        </span>
      </div>

      <div className="rp-mz-wort">
        <strong>Raporto</strong>
        <small>Administration, die mitarbeitet.</small>
      </div>
    </div>
  )
}
